export const SHOW_BIRD_ONE = 'SHOW_BIRD_ONE';
export const SHOW_BIRD_TWO = 'SHOW_BIRD_TWO';
export const SHOW_BIRD_THREE = 'SHOW_BIRD_THREE';
export const SHOW_BIRD_FOUR = 'SHOW_BIRD_FOUR';
export const SHOW_BIRD_FIVE = 'SHOW_BIRD_FIVE';
export const SHOW_BIRD_SIX = 'SHOW_BIRD_SIX';
export const SHOW_TEXT = 'SHOW_TEXT';
export const END_GAME = 'END_GAME';
export const START_GAME = 'START_GAME';